import { Stack } from "@fluentui/react/lib/Stack";

import { CustomPanel, CustomPanelSizeType } from "Components/Generic/CustomPanel";
import { IHeaderButtonProps } from "Components/Generic/CustomPanel/Header/Button";
import { Merge } from "Components/Generic/Merge";
import { IWithTranslatorProps, WithTranslator } from "Components/Generic/Translator";
import { Translator } from "Utils/Translator";
import { CompaniesSelection } from "./CompaniesSelection/CompaniesSelection";
import { IUseStaging } from "./IUseStaging";
import { useStagingStyles } from "./UseStagingStyles";
import { useStaging } from "./UseStaging";

export const Staging = WithTranslator((props: IWithTranslatorProps): JSX.Element => {
  const { translator } = props;
  const useStagingProps = useStaging();
  const {
    isStagingOpen, entries, onDismiss, onMergeChange, newCompanies, onSelectAll
  } = useStagingProps;
  const styles = useStagingStyles();

  if (!isStagingOpen) {
    return null;
  }

  return (
    <CustomPanel
      customPanelSize={CustomPanelSizeType.large}
      className={styles.root}
      isLightDismiss
      isOpen={isStagingOpen}
      onDismiss={onDismiss}
      headerTitle={translator.get(`staging.title`, `Source data update`)}
      buttonAreaWidth="15%"
      {...getButtonProps(useStagingProps, translator)}
    >
      <Stack className={styles.container}>
        <Merge
          alternativeSourceToken="staging.merge.current"
          alternativeTargetToken="staging.merge.new"
          entries={entries}
          onChange={onMergeChange}
          onSelectAll={onSelectAll}
        />
        <CompaniesSelection companies={newCompanies} onMergeChange={onMergeChange} />
      </Stack>
    </CustomPanel>
  );
});

function getButtonProps(useStagingProps: IUseStaging, translator: Translator): IHeaderButtonProps {
  const { onSave, onSaveExport, useExport } = useStagingProps;
  let buttonProps: IHeaderButtonProps = {
    onButtonClick: onSave,
    buttonText: translator.get(`generic.saveclose`, `Save & Close`),
    buttonIcon: `SaveAndClose`
  };

  if (useExport) {
    buttonProps = {
      ...buttonProps,
      onSplitButtonClick: buttonProps.onButtonClick,
      splitButtonText: buttonProps.buttonText,
      splitButtonIcon: buttonProps.buttonIcon,
      onButtonClick: onSaveExport,
      buttonText: translator.get(`generic.saveexport`, `Save & Export`)
    };
  }

  return buttonProps;
}
